
<div id="app" ref="app" v-loading="!getLoadingState" v-on:touchstart="disableDoubleTap">
  <div class="offline" v-if="isOffline">Vous êtes hors connexion</div>
  <router-view v-if="getLoadingState"></router-view>
  <el-dialog title="Nouvelle version" :visible.sync="getUpdateAppAlerte" width="30%">
    <span>Une nouvelle version de l'application est disponible, cliquez sur "OK" pour recharger l'application</span>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="updateStart" type="primary" @click="updateApp">OK</el-button>
      <div class="update-start" v-if="!updateStart">Chargement de la nouvelle version en cours</div>
    </span>
  </el-dialog>
</div>
